export default __webpack_public_path__ + "static/media/solucao-04.a2c73c96.webp";